<div class="teaser-container-wrapper">
  <div
    class="teaser-container-link"
    [ngClass]="{ 'teaser-container-link--no-headline': !linkHeadline }"
    *ngIf="linkHeadline || link"
  >
    <h4 *ngIf="linkHeadline">{{ linkHeadline }}</h4>
    <hdi-link
      *ngIf="link"
      [label]="link.label | capitalize"
      [type]="LinkType.PRIMARY_ARROW"
      [href]="link.href!"
      [title]="link.title ?? ''"
      [hrefType]="link.hrefType!"
    ></hdi-link>
  </div>
  <div
    #teaserList
    class="teaser-container"
    [ngClass]="{
      'teaser-container--3-col': columns === 0 || columns === 3,
      'teaser-container--2-col': columns === 2,
      'teaser-container--no-overflow': !showMoreLess,
    }"
  >
    <ng-content></ng-content>

    <ng-container *ngIf="type === 'standard'">
      <hdi-teaser
        *ngFor="let teaser of caasData?.formData?.st_items?.value"
        [caasData]="teaser"
        [columns]="columns"
        [reverse]="imageOrientation === 'Rechts'"
        [layout]="caasData?.formData?.st_layout?.value?.identifier"
        [className]="
          caasData?.formData?.st_layout?.value?.identifier === 'horizontal'
            ? 'quer'
            : ''
        "
      ></hdi-teaser>
    </ng-container>
    <!-- News Teasers -->
    <ng-container *ngIf="newsTeasers$ | async as newsTeasersList">
      <hdi-teaser
        *ngFor="let teaser of newsTeasersList"
        [imageBorder]="teaser.imageBorder"
        [badges]="teaser.badges"
        [type]="teaser.type"
        [headline]="teaser.headline"
        [description]="teaser.description"
        [imageSrc]="teaser.imageSrc"
        [imageAlt]="teaser.imageAlt"
        [imageTitle]="teaser.imageTitle"
        [target]="teaser.target"
        [label]="teaser.label ?? '' | capitalize"
        [href]="teaser.href ? teaser.href : ''"
        [hrefType]="teaser.hrefType ? teaser.hrefType : HrefType.ANGULAR_ROUTE"
        [columns]="columns"
        [layout]="caasData?.formData?.st_layout?.value?.identifier"
      ></hdi-teaser>
    </ng-container>
  </div>
  <div class="teaser-container-button" *ngIf="showMoreLess">
    <hdi-button
      [type]="ButtonType.SECONDARY_ICON"
      [label]="showMoreLessLabel | capitalize"
      [iconName]="iconSelected"
      (click)="toggleTeasersVisibility()"
    ></hdi-button>
  </div>
</div>
